
/**
 * The booking-summary CTA answers exactly ONE question: does a payment step
 * follow NOW? That is a property of the BOOKING MODE the tenant configured
 * ("Wie wird gebucht?"), never of the use case:
 *
 *   - Direktbuchung in der Web-App → the customer pays now  → "Weiter zur Zahlung"
 *   - Nur Reservierung             → no payment step now    → "Weiter zur Reservierung"
 *
 * Payment TIMING is a further axis and changes nothing here: a reservation is
 * pre-pay (bank transfer after confirmation) or post-pay (invoice after use),
 * and in neither case does the customer pay at this point in the flow.
 *
 * One rule, one place (PO, 2026-09-03). Before this the statement was
 * hardcoded in two per-use-case i18n keys — `apartment_overview.
 * reservation_request` ("Weiter zur Zahlung") for Gästewohnung and
 * `venue_reservation_overview.reservation_request` ("Weiter zur Reservierung")
 * for Veranstaltungsraum — which is correct on `neuland` only by luck, because
 * its Gästewohnung happens to be pre-pay. A Gästewohnung on post-pay (reachable
 * configuration: postpay v1 covers venue AND apartment, #2352 decision D9) got
 * a button promising a payment step that never comes.
 *
 * Both labels are existing keys with DE/EN copy — this rule deliberately adds
 * no third per-use-case key.
 *
 * A covered booking (#1926) is the one exception to "mode decides": it is
 * confirmed when sent and nothing is paid, so it reads "Jetzt buchen" (the
 * existing `apartment_overview.book_now` key) in either mode — PO, 2026-10-12.
 */
export const summaryCtaLabelKey = (directBooking: boolean, covered = false): string => {
  // A covered booking is confirmed the moment it is sent, in either mode —
  // no payment follows and nothing waits for review — so the button says
  // what it does: "Jetzt buchen" (PO, 2026-10-12; covered bookings step C).
  if (covered) return COVERED_BOOK_NOW_KEY;
  return directBooking
    ? "book_location.confirmation.proceed_to_payment"
    : "book_location.venue_reservation_overview.reservation_request";
};

/** "Jetzt buchen" — the existing key, reused for a covered booking. */
export const COVERED_BOOK_NOW_KEY = "book_location.apartment_overview.book_now";

export default summaryCtaLabelKey;
